export enum EventTypes {
  PAGE_VIEW = 'pageView',
  CONTACT_FORM_SUBMIT = 'contactContactSubmit',
}
